/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
} from "../CreateEvent/style";

import { AddIconRecognition, closeIcon, CloseIconBranding, PromotionalDocIcon, RecognitionCloseIcon, RemoveIcon, UploadHDMIcon, UploadIconSVG, WeekDropdownIcon } from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import Editor from "../CKEditor";
import { Main } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import { RadioButton, RadioButtonWrapper } from "../RecogntionAdmin/styles";
import { ActionButton, AudioUploadBox, MoreOptionText, OptionsContainer, ToggleCircle, ToggleContainer, ToggleWrapper, WeekContainer, WeekWrapper } from "./styles";
import { InputImage, RemoveImageV2, UploadPhotoContainer } from "../common/CommonImageUploader/style";
import { AddWellnessChallenge, ConvertCsvToJson, GetChallengeLevel } from "../../redux/constants/apiConstants";
import { wellnessChallengePoints } from "../../../mockData";
import { toast } from "react-toastify";
import { /*checkBase64,*/ deleteFromS3, fetchApi, uploadToS3 } from "../../utils/methods";
import CSVList from "../PeopleHomeV2/CSVList";
import Waiting from "../Waiting";
// import { ImageUrl } from "../../utils/constants";
import Spinner from "../common/Spinner";
// import CommonImageUploaderNew from "../common/CommonImageUploader/CommonImageUploaderNew";
// import Spinner from "../common/Spinner";

const sampleData = [
  { week: 1, day: 1, task: "Task 1", video_link: "https://example.com/video1", "goalNotification": "Notification for goal based task", "journalingNotification": "Notification for journaling task", "notCompletedNotification": "Notification for not completed task" },
  { week: 1, day: 2, task: "Task 2", video_link: "https://example.com/video2", "goalNotification": "Notification for goal based task", "journalingNotification": "Notification for journaling task", "notCompletedNotification": "Notification for not completed task" },
  { week: 1, day: 3, task: "Task 3", video_link: "https://example.com/video3", "goalNotification": "Notification for goal based task", "journalingNotification": "Notification for journaling task", "notCompletedNotification": "Notification for not completed task"  },
  { week: 1, day: 4, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 5, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 6, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 7, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 1, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 2, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 3, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 4, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 5, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 6, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 7, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 1, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 2, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 3, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 4, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 5, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 6, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 7, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 1, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 2, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 3, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 4, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 5, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 6, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 7, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 1, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 2, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 3, task: "", video_link: "" , "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
];

class CreateChallengeForm extends Component {
  constructor(props) {
    super(props);
    this.csvInputRef = React.createRef();
    this.state = {
      title: "",
      videoTitle: "",
      videoUrl: "",
      challenge_level: null,
      pointValue: "",
      url: "",
      pillar_Id: this.props.history.location?.state?.category_Id,
      categoryDescription:this.props.history.location?.state?.categoryDescription,
      options: ["", ""],
      activeQuestion: 0,
      feedbackActiveQuestion: 0,
      description: "",
      selectedLinkOption: 0,
      imageName: "",
      imageNameThumbnail:"",
      challengePointValue: null,
      challengePointKey: null,
      imgThumbnail:"",
      audio: '',
      imgSrc: "",
      primaryImgSrc: "",
      eliteImgSrc: "",
      classTypeKey: "",
      primaryImageName: "",
      eliteImageName: "",
      // WellbeingPillars:[],
      selectedValues: [],
      buttonstatus: false,
      step: 1,
      selectedChallengePoint: '',
      file: null,
      fileName: "",
      csvUpload: false,
      points: null,
      so: false,
      audioName: '',
      isVideoUrl: false,
      showBack: false,
      buttonClickScrollTop: false,
      so2: false,
      // levelOpen: true,
      question: "",
      levels: null,
      loading: false,
      so3: false,
      audio_link: "",
      iseventUrlMsg: "",
      coachName: '',
      levelNumber: null,
      printSampleBiometricCSV: false,
      charCount: 0,
      selectedOption: 0,
      selectedAudioVideoOption: 0,
      onSiteCategories: [],
      getThemesValue: [],
      selectedCategory: null,
      questions: [
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      feedBackQuestions: [
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      themeId: null,
      active: false,
      expandedWeek: 0, // index of currently expanded week (0-based)
      weeksData: Array.from({ length: 5 }, (_, weekIndex) => {
        const days = weekIndex === 4 ? 3 : 7; // 5th week → 3 days
      
        return Array.from({ length: days }, () => ({
          task: "",
          video_link: "",
          media_type: "yes-no",
          media_link: "",
          media_thumbnail: "",
          goalNotification: "",
          journalingNotification: "",
          notCompletedNotification: "",
        }));
      })
    };
  }



  componentDidMount() {
    if (this.props.history.location?.state?.category_Id) {
      this.setState({ pillar_Id: this.props.history.location?.state?.category_Id });
      this.GetChallengeLevelNumber();
    }


  }


  printAction = (bool) => {
    this.setState({ printSampleBiometricCSV: bool });
  }


  


  isUrl = (videoUrl) => {
    const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  
    // ✅ If empty → no error
    if (!videoUrl) {
      this.setState({
        isVideoUrl: false,
        iseventUrlMsg: "",
      });
      return;
    }
  
    if (UrlRegex.test(videoUrl)) {
      this.setState({
        isVideoUrl: true,
        iseventUrlMsg: "",
      });
    } else {
      this.setState({
        isVideoUrl: false,
        iseventUrlMsg: "Please enter valid URL",
      });
    }
  };



  toggleWeek = (weekIndex) => {
    this.setState((prevState) => ({
      expandedWeek: prevState.expandedWeek === weekIndex ? null : weekIndex
    }));
  };



  onSelectPoints = (name) => {
    this.setState({
      selectedChallengePoint: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
    });
  }


  onChangeInput = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }

    if (e.target.name === "videoUrl") {
      this.isUrl(e.target.value);
    }

  };




  // onChangeInputDay = (weekIndex, dayIndex, field, value) => {
  //   this.setState((prevState) => {
  //     const weeksData = [...prevState.weeksData];
  //     weeksData[weekIndex][dayIndex] = {
  //       ...weeksData[weekIndex][dayIndex],
  //       [field]: value
  //     };
  //     return { weeksData };
  //   });
  // };

  onChangeInputDay = (weekIndex, dayIndex, field, value,uploadField,uploadFieldValue) => {
    this.setState((prevState) => {
      const weeksData = [...prevState.weeksData];


      // ✅ BLOCK SPECIAL CHARACTERS FOR TASK
      // if (field === "task") {
      //   const validTaskRegex = /^[a-zA-Z0-9\s]*$/;
  
      //   if (!validTaskRegex.test(value)) {
      //     return null;
      //   }
      // }
  
      if (field === "media_type") {
        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          media_type: value,
          // media_link: "",
          // media_thumbnail: "",
          [uploadField]:uploadFieldValue || false
        };
      } else {
        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          [field]: value,
          [uploadField]:uploadFieldValue || false
        };
      }
  
      return { weeksData };
    });
  };


  onChangeURL = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        url: e.target.value,
      });
    }
  };

  // removeThumbnailPhoto = () => {
  //   this.setState({
  //     imgThumbnail: "",
  //     imageNameThumbnail: "",
  //   });
  // };

  removeThumbnailPhoto=async (day) => {
    const url = day?.media_thumbnail;
  
    await deleteFromS3(url);
  
    
  }

  onRemoveAudio=async (day) => {
    const url = day?.media_link;
  
    await deleteFromS3(url);
  
  }

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  // removePrimaryPhoto = () => {
  //   this.setState({
  //     primaryImgSrc: "",
  //     primaryImageName: "",
  //   });
  // };


  // removeElitePhoto = () => {
  //   this.setState({
  //     eliteImgSrc: "",
  //     eliteImageName: "",
  //   });
  // };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }

  onThumbnailChange = (baseImage, imageName) => {
    this.setState({
      imgThumbnail: baseImage,
      imageNameThumbnail: imageName,
    });
  }


  // onPrimaryChange = (baseImage, imageName) => {
  //   this.setState({
  //     primaryImgSrc: baseImage,
  //     primaryImageName: imageName,
  //   });
  // }


  // onEliteChange = (baseImage, imageName) => {
  //   this.setState({
  //     eliteImgSrc: baseImage,
  //     eliteImageName: imageName,
  //   });
  // }


  onChangeSilverImage = (baseImage, imageName) => {
    this.setState({
      silverBadgeImgSrc: baseImage,
      silverBadgeImageName: imageName,
    });
  }

  prepareStep3Payload = () => {
    const { weeksData } = this.state;
  
    const tasks = [];
  
    weeksData.forEach((week, weekIndex) => {
      week.forEach((day, dayIndex) => {
        tasks.push({
          week: weekIndex + 1,
          day: dayIndex + 1,
          task: day.task || "",
          task_goal: day.goalNotification || "",
          journaling_prompt: day.journalingNotification || "",
          media_type: day.media_type || "yes-no",
          media_link:
            day.media_type === "mp4" ? day.video_link : day.media_type === "mp3"
              ? day.media_link || null
              : null,
          // media_thumbnail:
          //   day.media_type === "mp3"
          //     ? day.media_thumbnail || null
          //     : null,
        });
      });
    });
  
    return {
      "step-3": {
        tasks
      }
    };
  };

  // prepareStep3Payload = () => {
  //   const { weeksData } = this.state;

  //   const tasks = [];

  //   weeksData.forEach((week, weekIndex) => {
  //     week.forEach((day, dayIndex) => {
  //       tasks.push({
  //         week: weekIndex + 1,
  //         day: dayIndex + 1,
  //         task: day.task || "",
  //         video_link: day.video_link || "",
  //       });
  //     });
  //   });

  //   return {
  //     "step-3": {
  //       tasks: tasks
  //     }
  //   };
  // };


  prepareStepFourPayload = () => {
    const { questions } = this.state;
    window.console.log("questions",questions)

    return {
      "step-4": {
        has_pre_quiz: true, // or dynamic if you add a toggle
        pre_quiz_questions: questions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };

  prepareStepFivePayload = () => {
    const { feedBackQuestions } = this.state;

    return {
      "step-5": {
        has_post_quiz: false, // or dynamic if you add a toggle
        post_quiz_questions: feedBackQuestions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };


  GetChallengeLevelNumber = async () => {
    const { pillar_Id } = this.state;
    let apiUrl = GetChallengeLevel + "/" + pillar_Id;
    try {
      const res = await fetchApi(apiUrl, "GET");

      if (res?.status === "success") {
        toast.success(res.data[0]);
        this.setState({ challenge_level: res.data.current_level });

      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error);
    }
  }



  saveChallengeDetails = () => {
    const {
      title,
      description,
      imgSrc,
      videoTitle,
      videoUrl,
      challenge_level,
      challengePointValue,
      pillar_Id,
      audio_link
    } = this.state;
    this.setState({
      // buttonStatus: true,
      loading: true
    });


    const step3Payload = this.prepareStep3Payload();
    const step4Payload = this.prepareStepFourPayload();
    const step5Payload = this.prepareStepFivePayload();

    ChallengeData = {
      "step-1": {
        "pillar_id": pillar_Id,
        "title": title,
        "description": description,
        "image": imgSrc,
      },
      "step-2": {
        "intro_media_title": videoTitle,
        "intro_media_link": this.state.selectedLinkOption === 0 ? audio_link   : videoUrl,
        "intro_media_type": this.state.selectedLinkOption === 0 ? "mp3" : this.state.selectedLinkOption === 1 ? "mp4" : null,
        // "intro_video_thumbnail": "base64_encoded_thumbnail",
        "challenge_level": challenge_level,
        "points": challengePointValue,
      },
      ...step3Payload,
      ...step4Payload,
      ...step5Payload,
    }
    this.PostCreateChallenge(ChallengeData);
  };


  PostCreateChallenge = async (payload) => {
    try {
      const res = await fetchApi(AddWellnessChallenge, "POST", payload);

      if (res?.status === "success") {
        const categoryData = this.props.history.location?.state?.categoryData;
        toast.success(res.data[0]);
        this.props.history.push({ pathname: `/company/challenges/challenge-category/${this.props.history.location?.state?.category_Id}`,state:{...categoryData} })
        // this.redirect()
        this.setState({
          // buttonStatus: false,
          loading: false
        });
      } else {
        toast.error(res.data.message);
        this.setState({
          // buttonStatus: false,
          loading: false
        });
      }
    } catch (error) {
      toast.error(error);
      this.setState({
        // buttonStatus: false,
        loading: false
      });
    }
  }


  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
      trimmedString.length === 7 ||
      trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });

    const plainText = newContent.replace(/<[^>]*>/g, "").trim();
    const currentLength = plainText.length;
    this.setState({ charCount: currentLength });
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };


  redirect = () => {
    this.props.history.goBack();
  }

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      Create {this.state.categoryDescription} Challenge
    </FormHeading>
  );



  stepOneForm = () => {
    const {
      description,
      step,
      charCount,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">

              <div className="formBody">

                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the challenge")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter challenge title/name")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="50"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{this.state.title?.length}/50 | C</div>
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                <div style={{ display: "flex", gap: "12px" }}>
                  <div>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Challenge image")}<span className="subtext">{("(use illustration)")}</span>{<span>*</span>}</StyledLabel>
                    <CommonImageUploader
                      imgSrc={this.state.imgSrc}
                      t={t}
                      closeIcon={closeIcon}
                      UploadIcon={UploadHDMIcon}
                      onImageChange={this.onChange}
                      onRemoveImage={this.removePhoto}
                      isMaxSize={true}
                    />
                  </div>
                  {/* <div>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Primary Badge")} <span className="subtext">{("(use illustration)")}</span>{<span>*</span>}</StyledLabel>
                    <CommonImageUploader
                      imgSrc={this.state.primaryImgSrc}
                      t={t}
                      closeIcon={closeIcon}
                      UploadIcon={UploadHDMIcon}
                      onImageChange={this.onPrimaryChange}
                      onRemoveImage={this.removePrimaryPhoto}
                      isMaxSize={true}
                      accept={".svg, .png"}
                    />
                  </div> */}
                  {/* <div>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Elite Badge")} <span className="subtext">{("(use illustration)")}</span>{<span>*</span>}</StyledLabel>
                    <CommonImageUploader
                      imgSrc={this.state.eliteImgSrc}
                      t={t}
                      closeIcon={closeIcon}
                      UploadIcon={UploadHDMIcon}
                      onImageChange={this.onEliteChange}
                      onRemoveImage={this.removeElitePhoto}
                      isMaxSize={true}
                      accept={".svg, .png"}
                    />
                  </div> */}

                </div>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <InputContainer isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About the challenge")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} placeholder={"Enter challenge description"} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value }, () => { });
  };


  toggleLinkRadioButton = (value) => {
    this.setState({ selectedLinkOption: value }, () => { });
  };



  toggleAudioVideoRadioButton = (value) => {
    this.setState({ selectedAudioVideoOption: value }, () => { });
  };



  onDropDownSelect = (key, item) => {
    this.setState({
      [key]: item
    });
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };

  stepTwoForm = () => {
    const {
      step,
      challengePointValue,
      challengePointKey,
      iseventUrlMsg,
      selectedLinkOption,
      audio_link


    } = this.state;


    window.console.log("audio_link",audio_link)

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" >
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">
              <div className="formBody" >


                <div className="radioButtonDiv" style={{marginBottom:"12px"}}>
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedLinkOption === 0}
                        onChange={() => this.toggleLinkRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"Upload audio"}</div>
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedLinkOption === 1}
                        onChange={() => this.toggleLinkRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Upload video link"}</div>
                    </div>
                  </RadioButtonWrapper>
                </div>



                { selectedLinkOption === 0 ?  audio_link ? (
                  <>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                    <UploadPhotoContainer showBorder={false}>
                      <div className="innerDivImageContainer">
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">
                                {PromotionalDocIcon()}
                              </div>
                              <div>
                                <span className="promotional-doc-name">
                                  Audio uploaded successfully!
                                </span>
                              </div>
                            </div>
                  
                            <div className="main-div" onClick={this.onRemoveAudioLink}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#DA6C74", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      </div>
                    </UploadPhotoContainer>
                  </>
                ) : (
                  <>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                    <AudioUploadBox>
                      <div style={{ marginBottom: "8px" }}>
                        <UploadIconSVG />
                      </div>
                      <div style={{ color: "#184A61", fontWeight: "bold" }}>
                        Upload Audio
                      </div>
                      <div style={{ color: "#666", fontSize: "12px" }}>
                        (.mp3)
                      </div>
                      <input
                        type="file"
                        accept=".mp3,audio/mpeg"
                        onChange={this.onChangeAudioLink}
                      />
                    </AudioUploadBox>
                  </>
                ) : null}



                {selectedLinkOption === 1 ?  <>
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video Title")}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter title")}
                      name="videoTitle"
                      onChange={this.onChangeInput}
                      value={this.state.videoTitle}
                      maxLength="30"
                      style={{ background: "white" }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                  </InputContainer>
  
                  <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video")}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter URL")}
                      name="videoUrl"
                      onChange={this.onChangeInput}
                      value={this.state.videoUrl}
                      maxLength="30"
                      style={{ background: "white" }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                    <span style={{ color: "#DA6C74", fontFamily: "Lato", fontSize: '12px' }}>{iseventUrlMsg}</span>
                  </InputContainer>

                </>:null}


               

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Challenge Level")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Level number")}
                    name="challenge_level"
                    onChange={this.onChangeInput}
                    value={`Level ${this.state.challenge_level}`}
                    maxLength="30"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                    disabled
                  />
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />


                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={("Challenge point value")}
                  isSubText={"(per day)"}
                  dropdownOpen={this.state.so}
                  placeholder={("Select Point")}
                  // title={challengePointKey=="0 Points"?"No Points":challengePointKey ? (challengePointKey) : ("Select point")}
                  title={
                    challengePointKey
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={wellnessChallengePoints}
                  onSelect={this.onSelectPoints}
                  active={challengePointValue}
                  itemValue={true}
                  onSelectParameter={["value", "key"]}
                  // onSelectParameter={["month", "id", "theme_icon"]}
                  dropIcon={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  isRequired={true}
                />

              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };






  handleFiles = (e) => {
    this.setState({
      file: "",
      fileName: "",
      csvUpload: false,
    });

    let file = e.target.files[0];
    if (!file) return;

    const fileName = file?.name;
    let checkCSV = fileName.split(".");
    if (checkCSV[checkCSV.length - 1].toLowerCase() !== "csv") {
      toast.error("Please select .csv format only");
      document.getElementById("csv-upload-input").value = "";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: reader.result ? reader.result : "data:",
        fileName: fileName,
        csvUpload: true,
        // data: [
        //   { fname: "", lname: "", mail: "" } // initial structure
        // ],
      }, () => {
        // ✅ Once state is set, immediately call your API
        this.PostCsvToJson();
      });
    };
  };

  




  PostCsvToJson = async () => {
    const { file } = this.state;
  
    const payload = {
      csv_base64: file,
    };
  
    try {
      const res = await fetchApi(ConvertCsvToJson, "POST", payload);
  
      if (res?.status === "success") {
        toast.success(res.data.message);
  
        const totalRows = res.data.total_rows;
        const data = res.data.data;
  
        // let hasInvalidChars = false;
  
        // const validTaskRegex = /^[a-zA-Z0-9\s]+$/;
  
        // ✅ STEP 1: VALIDATE ENTIRE CSV FIRST
        // for (let item of data) {
        //   let taskValue = (item?.task ?? "").toString().trim();
  
        //   if (taskValue !== "" && !validTaskRegex.test(taskValue)) {
        //     hasInvalidChars = true;
        //     break; // ❌ stop immediately
        //   }
        // }
  
        // ❌ BLOCK FULL CSV IF INVALID
        // if (hasInvalidChars) {
        //   toast.error(
        //     "Upload Failed: CSV contains unsupported special characters."
        //   );
        //   return;
        // }
  
        // ✅ STEP 2: CREATE EMPTY STRUCTURE



        window.console.log("weeksData",weeksData, data)
        const weeksData = Array.from({ length: 5 }, (_, weekIndex) => {
          const days = weekIndex === 4 ? 3 : 7;
  
          return Array.from({ length: days }, () => ({
            task: "",
            video_link: "",
            media_type: "",
            media_link: "",
            media_thumbnail: "",
            goalNotification: "",
            journalingNotification:  "",
            notCompletedNotification:  ""
          }));
        });

       
  
        // ✅ STEP 3: FILL DATA (now safe)
        data.forEach((item) => {
          const wIndex = item.week - 1;
          const dIndex = item.day - 1;
  
          if (!weeksData[wIndex] || !weeksData[wIndex][dIndex]) return;
  
          let mediaType = item?.video_link ? "mp4" : "yes-no";
  
          let taskValue = (item?.task ?? "").toString().trim();
  
          weeksData[wIndex][dIndex] = {
            task: taskValue,
            media_type: mediaType,
            video_link: item?.video_link ?? "",
            goalNotification: item?.goal_based_notification ?? "",
            journalingNotification: item?.journaling_prompt_notification ?? "",
            notCompletedNotification: item?.not_completed_notification ?? "",
          };
        });
  
        // ❌ Row validation (your choice: block or not)
        if (totalRows < 31) {
          toast.error(
            "Uploaded CSV is incomplete. Please ensure all days(31) of the month are filled before uploading."
          );
          return;
        } else if (totalRows > 31) {
          toast.error(
            "Uploaded CSV data is greater than required data. Please ensure 31 days data are filled before uploading"
          );
          return;
        }
  
        // ❌ Empty task check
        const hasEmptyTaskEachLine = weeksData.some((week) =>
          week.some((day) => !day.task || day.task.trim() === "")
        );
  
        if (hasEmptyTaskEachLine) {
          toast.error(
            "Uploaded CSV is incomplete. Please ensure all days of the month are filled before uploading."
          );
        }
  
        // ✅ SET DATA
        this.setState({
          weeksData,
          expandedWeek: 0,
        });
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };



  // PostCsvToJson = async () => {
  //   const { file } = this.state;
  //     const res = await fetchApi(ConvertCsvToJson, "POST", payload);

  //     if (res?.status === "success") {
  //       toast.success(res.data.message);
  //       // const weeksData = Array(4).fill().map(() =>
  //       //   Array(7).fill().map(() => ({
  //       //     task: "",
  //       //     video_link: "",
  //       //     media_type: "",
  //       //     media_link: "",
  //       //     media_thumbnail: ""        
  //       //   }))
  //       // );

  //       if(res.data.total_rows < 31){
  //         toast.error('Uploaded CSV is incomplete. Please ensure all days(31) of the month are filled before uploading.')
  //         return;
  //       }else if(res.data.total_rows > 31){
  //         toast.error('Uploaded CSV data is greater that required data. Please ensure 31 days data are filled before uploading.')
  //         return;
  //       }
        

  //       const weeksData = Array.from({ length: 5 }, (_, weekIndex) => {
  //         const days = weekIndex === 4 ? 3 : 7; // 5th week → 3 days
        
  //         return Array.from({ length: days }, () => ({
  //           task: "",
  //           video_link: "",
  //           media_type: "",
  //           media_link: "",
  //           media_thumbnail: ""
  //         }));
  //       })


  //       // let hasEmptyTask = false;
  //       let hasInvalidChars = false;
  //       let hasEmptyTaskEachLine = false;

  //       // Fill the weeksData with the JSON values
  //       res.data.data.forEach((item) => {
  //         const wIndex = item.week - 1;
  //         const dIndex = item.day - 1;
        
  //         if (weeksData[wIndex] && weeksData[wIndex][dIndex]) {
        
  //           // ✅ fallback logic
  //           let mediaType = "yes-no";

  //           if (item?.video_link) {
  //             mediaType = 'mp4';
  //           }

  //           let taskValue = (item?.task ?? "").toString().trim();
  
  //           // ✅ 2. EMPTY TASK CHECK
  //           // if (taskValue === "") {
  //           //   hasEmptyTask = true;
  //           // }
    
  //           // ✅ 3. SPECIAL CHARACTER CHECK
  //           const validTaskRegex = /^[a-zA-Z0-9\s]+$/;
    
  //           if (taskValue !== "" && !validTaskRegex.test(taskValue)) {
  //             hasInvalidChars = true;
  //             taskValue = "";
  //           }




        
  //           // if (item.mediatype) {
  //           //   mediaType = item.mediatype;
  //           // } else if (item?.medialink) {
  //           //   mediaType = "mp4"; // since only audio exists
  //           // }
        
  //           weeksData[wIndex][dIndex] = {
  //             // task: typeof item.task === "string" ? item.task : "",
  //             task: taskValue,
  //             media_type: mediaType,
  //             // media_link: item.medialink || "",
  //             // media_thumbnail: item.mediathumbnail || "",
  //             video_link:item?.video_link || null
  //           };
  //         }
  //       });

  //       hasEmptyTaskEachLine = weeksData.some((week) =>
  //         week.some((day) => !day.task || day.task.trim() === "")
  //       );


  //       if (hasInvalidChars) {
  //         toast.error(
  //           "Upload Failed: CSV contains unsupported special characters."
  //         );
  //         return;
  //       }

  //       if ( hasEmptyTaskEachLine) {
  //         toast.error(
  //           "Uploaded CSV is incomplete. Please ensure all days of the month are filled before uploading."
  //         );
  //         return;
  //       }
  
       

      
  //       // 🔹 Set state so form auto-fills
  //       this.setState({ weeksData, expandedWeek: 0 });

  //       // this.setState({
  //       //   weeksData: res.data.data, // Assuming the API returns weeksData in the expected format
  //       //   expandedWeek: 0, 
  //       // });
  //     } else {
  //       toast.error(res.data.message);
  //     }
  //   } catch (error) {
  //     toast.error(error);
  //   }
  // }


  // PostCsvToJsond = async () => {
  //   const { file } = this.state;
  
  //   const payload = {
  //     csv_base64: file,
  //   };
  
  //   try {
  //     const res = await fetchApi(ConvertCsvToJson, "POST", payload);
  
  //     if (res?.status === "success") {
  //       toast.success(res.data.message);
  
  //       const totalRows = res.data.total_rows;
  
  //       // ✅ 1. Row count validation FIRST
  //       if (totalRows < 31) {
  //         toast.error(
  //           "Uploaded CSV is incomplete. Please ensure all days (31) of the month are filled before uploading."
  //         );
  //       }
  
  //       if (totalRows > 31) {
  //         toast.error(
  //           "Uploaded CSV data is greater than required data. Please ensure 31 days data are filled before uploading."
  //         );
  //       }
  
  //       // ✅ Build empty weeks structure
  //       const weeksData = Array.from({ length: 5 }, (_, weekIndex) => {
  //         const days = weekIndex === 4 ? 3 : 7;
  
  //         return Array.from({ length: days }, () => ({
  //           task: "",
  //           video_link: "",
  //           media_type: "",
  //           media_link: "",
  //           media_thumbnail: "",
  //         }));
  //       });
  
  //       let hasEmptyTask = false;
  //       let hasInvalidChars = false;
  
  //       // ✅ Fill data
  //       res.data.data.forEach((item) => {
  //         const wIndex = item.week - 1;
  //         const dIndex = item.day - 1;
  
  //         if (!weeksData[wIndex] || !weeksData[wIndex][dIndex]) return;
  
  //         let mediaType = item?.video_link ? "mp4" : "yes-no";
  
  //         let taskValue = (item?.task ?? "").toString().trim();
  
  //         // ✅ 2. EMPTY TASK CHECK
  //         if (taskValue === "") {
  //           hasEmptyTask = true;
  //         }
  
  //         // ✅ 3. SPECIAL CHARACTER CHECK
  //         const validTaskRegex = /^[a-zA-Z0-9\s]+$/;
  
  //         if (taskValue !== "" && !validTaskRegex.test(taskValue)) {
  //           hasInvalidChars = true;
  //           taskValue = "";
  //         }
  
  //         weeksData[wIndex][dIndex] = {
  //           task: taskValue,
  //           media_type: mediaType,
  //           video_link: item?.video_link ?? "",
  //         };
  //       });
  
  //       // ✅ PRIORITY ERROR HANDLING
  
  //       if (hasEmptyTask) {
  //         toast.error(
  //           "Uploaded CSV is incomplete. Please ensure all days of the month are filled before uploading."
  //         );
  //       }
  
  //       if (hasInvalidChars) {
  //         toast.error(
  //           "Please enter text and numbers only (no special characters)"
  //         );
  //         return;
  //       }
  
  //       // ✅ set state only if valid
  //       this.setState({
  //         weeksData,
  //         expandedWeek: 0,
  //       });
  //     } else {
  //       toast.error(res.data.message);
  //     }
  //   } catch (error) {
  //     toast.error(error?.message || "Something went wrong");
  //   }
  // };


  removeFile = () => {
    // Reset file input field
    const fileInput = document.getElementById('new-employee-file');
    if (fileInput) {
      fileInput.value = '';
    }

    // Reset state
    this.setState({
      csvUpload: false,
      fileName: '',
      file: ''
    });
  };

  onChangeAudioLink = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    // ✅ Validation
    if ((file.size / 1000000) > 10) {
      return toast.error("Max 10MB");
    }
  
    if (file.type !== "audio/mpeg") {
      return toast.error("Only MP3 allowed");
    }
  
    // ✅ Show loader
    this.setState({ audioUploadLoading: true });
  
    const reader = new FileReader();
    reader.readAsDataURL(file);
  
    reader.onloadend = async () => {
      try {
        const s3Url = await uploadToS3(
          reader.result,
          `wellness/challenges/media`
        );
  
        if (s3Url?.path) {
          this.setState({
            audio_link: s3Url.path,
            media_type: "mp3",
            audioUploadLoading: false,
          });
        } else {
          this.setState({
            audio_link: "",
            audioUploadLoading: false,
          });
          toast.error("Upload failed");
        }
      } catch (error) {
        console.error(error);
        this.setState({ audioUploadLoading: false });
        toast.error("Something went wrong");
      }
    };
  };


  onRemoveAudioLink = async () => {
    const { audio_link } = this.state;
  
    try {
      if (audio_link) {
        await deleteFromS3(audio_link);
      }
  
      this.setState({
        audio_link: "",
        media_type: "",
      });
    } catch (error) {
      console.error(error);
    }
  };







  removeAudio = (e) => {
    e.preventDefault();
    this.setState({ audio: '', audioName: '' });
  };


  onChangeAudio = async (e, weekIndex, dayIndex) => {
    const file = e.target.files[0];
    if (!file) return;
  
    if ((file.size / 1000000) > 10) {
      return toast.error("Max 10MB");
    }
  
    if (file.type !== "audio/mpeg") {
      return toast.error("Only MP3 allowed");
    }
  
    const reader = new FileReader();
    reader.readAsDataURL(file);
  
    reader.onloadend = async () => {
      this.setState((prevState) => {
        const weeksData = [...prevState.weeksData];
    
        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          audioUploadLoading:true
        };
    
        return { weeksData };
      });

      const s3Url = await uploadToS3(reader.result, `wellness/challenges/media`);
  
      if (s3Url?.path) {
        this.onChangeInputDay(weekIndex, dayIndex, "media_link", s3Url?.path,"audioUploadLoading", false);
      }else{
        this.onChangeInputDay(weekIndex, dayIndex, "media_link", null,"audioUploadLoading", false);
      }
    };
  };

  // onThumbnailChangeDay = async (baseImage,imageName, weekIndex, dayIndex) => {
  //   this.setState((prevState) => {
  //     const weeksData = [...prevState.weeksData];
  
  //     weeksData[weekIndex][dayIndex] = {
  //       ...weeksData[weekIndex][dayIndex],
  //       thumbnailUploadLoading:true
  //     };
  
  //     return { weeksData };
  //   });

  //   const s3Url = await uploadToS3(
  //     baseImage,
  //     `wellness/challenges/media`
  //   );
  
  //   if (s3Url?.path) {
  //     this.onChangeInputDay(weekIndex, dayIndex, "media_thumbnail", s3Url?.path,"thumbnailUploadLoading", false);
  //   }else{
  //     this.onChangeInputDay(weekIndex, dayIndex, "media_thumbnail", null,"thumbnailUploadLoading", false);
  //   }
  // };


  getCSVHeaders = () => {
    const csvHeaders = [
      { label: "Week", key: "week" },
      { label: "Day", key: "day" },
      { label: "Task", key: "task" },
      { label: "Video Link", key: "video_link" },
      { label: "Goal Based Notification", key: "goalNotification" },
      { label: "Journaling Prompt Notification", key: "journalingNotification" },
      { label: "Not Completed Notification", key: "notCompletedNotification" },
      // { label: "Media Type", key: "media_type" },
      // { label: "Media Link", key: "media_link" },
      // { label: "Media Thumbnail", key: "media_thumbnail" },
    ];
    return csvHeaders;
  };

  


  stepThreeForm = () => {

    const {
      step,
      // t,
      // audioName,
      selectedOption,
      // selectedAudioVideoOption,
      fileName,
      csvUpload,
      printSampleBiometricCSV
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("How would you like to add challenge goal")}{<span>*</span>}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"CSV upload"}</div>
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Manual upload"}</div>
                    </div>
                  </RadioButtonWrapper>
                </div>

                {selectedOption === 0 ? <>
                  <Border style={{ background: '#EFEFEF', margin: '4px 0px' }} />
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add CSV document")}{<span>*</span>}</StyledLabel>
                  <UploadPhotoContainer showBorder={false}>
                    <div className="innerDivImageContainer">
                      {csvUpload ? (
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                              <div>
                                <span
                                  className="promotional-doc-name"
                                  title={fileName}
                                >
                                  {fileName}
                                </span>
                              </div>
                            </div>
                            <div className="main-div" onClick={this.removeFile}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#F37A65", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      ) : (
                        <div className="uploadImage">
                          <InputImage
                            className="edit-profile-pic"
                            imageReload={1}
                            style={{ background: "unset", color: "#184A61" }}
                          >
                            <div
                              className="middle-section"
                              onClick={() => this.csvInputRef.current.click()}
                            >
                              <div>{UploadHDMIcon()}</div>
                              <div className="title">{("Upload File")}</div>
                              <div className="sub-title">{("(.csv)")}</div>
                            </div>
                            <input
                              className="input-section"
                              id="csv-upload-input"
                              type="file"
                              accept=".csv"
                              multiple={false}
                              onChange={this.handleFiles}
                              ref={this.csvInputRef}
                              style={{ display: "none" }}
                            />
                          </InputImage>
                        </div>
                      )}
                    </div>
                  </UploadPhotoContainer>
                </> : null}

                {selectedOption === 0 && !csvUpload ? <ActionButton
                  onClick={() => this.setState({ printSampleBiometricCSV: true })}>
                  Download Sample
                </ActionButton> : null}
                {/* <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} /> */}

                {(csvUpload && selectedOption === 0) || selectedOption === 1 ? <WeekWrapper styel={{ marginTop: "20px" }} isDayText={"16px"}>
                  {this.state.weeksData.map((week, weekIndex) => (
                    <div key={weekIndex}>
                      {/* Week Header */}
                      <WeekContainer onClick={() => this.toggleWeek(weekIndex)} style={{ cursor: "pointer", marginTop: "20px" }}>
                        <div className="weeekText">Week {weekIndex + 1}</div>
                        <div style={{ transform: this.state.expandedWeek === weekIndex ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.3s" }}>
                          {WeekDropdownIcon("#DA6C74")}
                        </div>
                      </WeekContainer>


                      {weekIndex !== this.state.weeksData.length - 1 ? (
                        <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                      ) :
                        null
                      }

                      {/* (this.state.expandedWeek === weekIndex && (
                          <Border style={{ background: '#EFEFEF', margin:  '20px 0 8px 0px', display: "flex" }} />
                        )) */}


                      {/* Days - only render if expanded */}
                      {this.state.expandedWeek === weekIndex && week.map((day, dayIndex) => (
                        <React.Fragment key={dayIndex}>

                          {weekIndex === this.state.weeksData.length - 1
                            ? <Border style={{ background: '#EFEFEF', margin: '20px 0px 8px 0px', display: "flex" }} /> : null}
                          <div className="dayText">Day {dayIndex + 1}</div>

                          <InputContainer>
                            <StyledLabel isFont="14px" color="#184A61" margin="0px">
                              {this.props.t("Task")}<span>*</span>
                            </StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter task")}
                              value={day.task}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'task', e.target.value)}
                              maxLength="300"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                            <div className="count">{day.task.length}/300 | C</div>
                          </InputContainer>
                         
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                         
                          <InputContainer>
                            <StyledLabel  margin={"0px"}>{this.props.t("Notification")}  <span className="subtext">(Goal Based Notifiaction)</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              value={day.goalNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'goalNotification', e.target.value)}
                              maxLength="100"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                            <div className="count">{day.goalNotification?.length}/100 | C</div>

                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/> 
                          <InputContainer>
                            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Notification")} <span className="subtext">{("(Journaling Prompt)")}</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              name="journalingNotification"
                              value={day.journalingNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex,dayIndex, 'journalingNotification', e.target.value)}
                              maxLength="100"
                              style={{background:"white"}}
                              pColor={"#BDBDBD"}
                              color="#184A61"
                              border={"1px solid #BDBDBD"}
                            />
                            <div className="count">{day.journalingNotification?.length}/100 | C</div>

                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/> 
    
                          <InputContainer>
                            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Notification")} <span className="subtext">{("(If the task is not completed)")}</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              name="videoUrl"
                              value={day.notCompletedNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex,dayIndex, 'notCompletedNotification', e.target.value)}
                              maxLength="100"
                              style={{background:"white"}}
                              pColor={"#BDBDBD"}
                              color="#184A61"
                              border={"1px solid #BDBDBD"}
                            />
                            <div className="count">{day.notCompletedNotification?.length}/100 | C</div>

                          </InputContainer>
 
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/> 

                          <div className="radioButtonDiv">
                            <RadioButtonWrapper isMargin="0px"  gap width={"20%"}>
                              <div className="RadioButtonContainerNew">
                                <RadioButton
                                  type={"radio"}
                                  checked={day.media_type === 'yes-no'}
                                  // onChange={() => this.toggleAudioVideoRadioButton(0)}
                                  value={'yes-no'}
                                  id='yes-no'
                                  // value={day.media_type}
                                  onChange={() => this.onChangeInputDay(weekIndex, dayIndex, 'media_type', 'yes-no')}
                                />
                                <div className="label">{"Yes/No"}</div>
                              </div>
                              <div className="RadioButtonContainerNew">
                                <RadioButton
                                  type={"radio"}
                                  checked={day.media_type === 'mp3'}
                                  // onChange={() => this.toggleAudioVideoRadioButton(1)}
                                  value={'mp3'}
                                  id='mp3'
                                  // value={day.media_type}
                                  onChange={() => this.onChangeInputDay(weekIndex, dayIndex, 'media_type', 'mp3')}
                                />
                                <div className="label">{"Upload audio"}</div>
                              </div>
                              <div className="RadioButtonContainer">
                                <RadioButton
                                  type={"radio"}
                                  checked={day.media_type === 'mp4'}
                                  // onChange={() => this.toggleAudioVideoRadioButton(2)}
                                  value={'mp4'}
                                  id="mp4"
                                  // value={day.video_link}
                                  onChange={() => this.onChangeInputDay(weekIndex, dayIndex, 'media_type', 'mp4')}
                                />
                                <div className="label">{"Upload video link"}</div>
                              </div>
                            </RadioButtonWrapper>
                          </div>

                          {day.media_type === 'mp3' ? <div style={{ display: "flex", gap: "12px", marginTop:"12px"}}>
                            {/* <div>
                              <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Upload Thumbnail")}{<span>*</span>}</StyledLabel>
                              <CommonImageUploaderNew
                                imgSrc={day?.thumbnailUploadLoading ? null : day?.media_thumbnail ? checkBase64(day?.media_thumbnail) ? day?.media_thumbnail : ImageUrl + "/" + day?.media_thumbnail : null}
                                t={t}
                                closeIcon={closeIcon}
                                UploadIcon={UploadHDMIcon}
                                onImageChange={(baseImage,imageName) =>
                                  this.onThumbnailChangeDay(baseImage, imageName,weekIndex, dayIndex)
                                }
                                onRemoveImage={()=>{this.removeThumbnailPhoto(day);this.onChangeInputDay(weekIndex, dayIndex, "media_thumbnail", "");}}
                                isMaxSize={true}
                                loading={day?.thumbnailUploadLoading}
                              />
                            </div> */}
                            <div>
                              <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                              {day?.media_link ? (
                                <UploadPhotoContainer showBorder={false}>
                                  <div className="innerDivImageContainer">
                                    <RemoveImageV2>
                                      <div className="uploadImage">
                                        <div className="promotional-doc">
                                          <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                                          <div>
                                            <span
                                              className="promotional-doc-name"
                                              // title={audioName}
                                            >
                                            Audio uploaded successfully!
                                            </span>
                                            {/* <span className="successmsg">Audio uploaded successfully!</span> */}
                                          </div>
                                        </div>
                                        <div className="main-div" onClick={() =>{this.onRemoveAudio(day);this.onChangeInputDay(weekIndex, dayIndex, "media_link", "");}}>
                                          <div className="icon-div">
                                            <div className="sub-icon-div">
                                              {CloseIconBranding("#DA6C74", "8", "8")}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </RemoveImageV2>
                                  </div>
                                </UploadPhotoContainer>
                              ) : (
                                <AudioUploadBox>
                                  {day.audioUploadLoading ? <Spinner color={'#75B084'}/> :<> <div style={{ marginBottom: '8px' }}>
                                    <UploadIconSVG />
                                  </div>
                                  <div style={{ color: '#184A61', fontWeight: 'bold' }}>{('Upload Audio')}</div>
                                  <div style={{ color: '#666', fontSize: '12px' }}>{('(.mp3)')}</div></>}
                                  <input
                                    type="file"
                                    accept=".mp3,audio/mpeg"
                                    onChange={(e) => this.onChangeAudio(e, weekIndex, dayIndex)}
                                  />
                                </AudioUploadBox>
                              )}
                              {/* <div style={{ color: '#184A61', fontSize: '12px', marginBottom: '20px' }}>
                                {('Maximum file size 10 MB')}
                              </div> */}
                            </div>
                          </div> :null}



                          {day.media_type === 'mp4' ? 
                            <InputContainer>
                              <StyledLabel isFont="14px" color="#184A61" margin="12px">
                                {this.props.t("Video link")}
                              </StyledLabel>
                              <StyledInputV2
                                placeholder={this.props.t("Enter URL")}
                                value={day.video_link}
                                onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'video_link', e.target.value)}
                                maxLength="30"
                                style={{ background: "white" }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />
                            </InputContainer>
                            :null}



                          {weekIndex !== this.state.weeksData.length - 1 && (
                            <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </WeekWrapper> : null}
              </div>
            </div>
          </Container>
        </div>
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={sampleData} />}
      </Layout>
    )
  }



  handleQuestionChange = (qIndex, e) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].text = e.target.value;
    this.setState({ questions: newQuestions });
  };

  handleOptionChange = (qIndex, optionIndex, e) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options[optionIndex] = e.target.value;
    this.setState({ questions: newQuestions });
  };

  handleAddOption = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options.push("");
    // if (newQuestions[qIndex].options.length < 5) {
    //   newQuestions[qIndex].options.push("");
    // }
    this.setState({ questions: newQuestions });
  };

  toggleSwitch = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].allowMultiple = !newQuestions[qIndex].allowMultiple;
    this.setState({ questions: newQuestions });
  };


  handleFeedBackQuestionChange = (qIndex, e) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].text = e.target.value;
    this.setState({ feedBackQuestions: newQuestions });
  };

  handleFeedBackOptionChange = (qIndex, optionIndex, e) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].options[optionIndex] = e.target.value;
    this.setState({ feedBackQuestions: newQuestions });
  };

  handleFeedBackAddOption = (qIndex) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].options.push("");
    // if (newQuestions[qIndex].options.length < 5) {
    //   newQuestions[qIndex].options.push("");
    // }
    this.setState({ feedBackQuestions: newQuestions });
  };

  toggleFeedBackSwitch = (qIndex) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].allowMultiple = !newQuestions[qIndex].allowMultiple;
    this.setState({ feedBackQuestions: newQuestions });
  };


  handleAddQuestion = () => {
    this.setState((prevState) => ({
      questions: [
        ...prevState.questions,
        { text: "", options: ["", ""], allowMultiple: false }
      ],
      activeQuestion: prevState.questions.length // open newly added
    }));
  };


  // handleRemoveQuestion = (qIndex) => {
  //   this.setState((prevState) => {

  //     const updated = prevState.questions.filter((_, i) => i !== qIndex);
  //     return {
  //       questions: updated,
  //       activeQuestion: null
  //     };
  //   });
  // };



  handleRemoveOption = (qIndex, optionIndex) => {
    this.setState((prevState) => {
      const newQuestions = [...prevState.questions];

      // ❌ minimum 2 options should remain
      if (newQuestions[qIndex].options.length <= 2) {
        return prevState;
      }

      newQuestions[qIndex].options.splice(optionIndex, 1);

      return { questions: newQuestions };
    });
  };



  stepFourForm = () => {
    const { step, activeQuestion, questions } = this.state;
    // const optionLabels = ["A", "B", "C", "D", "E"];


    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isMinHeight={"320px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>

            <div className="form">
              <StyledLabel
                isFont="18px"
                color="#184A61"
                margin="0px"
                isFloat="none"
                isFontWeight="700"
              >
                {this.props.t("Add question you would like to ask the user before challenge starts")}
              </StyledLabel>

              {/* Loop through questions */}
              {questions.map((q, qIndex) => (
                <div key={qIndex}>
                  {/* Question Header */}
                  <WeekContainer
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        activeQuestion: activeQuestion === qIndex ? null : qIndex,
                      })
                    }
                  >
                    <div className="weeekText">Question {qIndex + 1}</div>

                    {/* <div style={{ display: "flex", gap: "10px" }}> */}
                    {/* Delete */}
                    {/* {questions.length >1 && <div onClick={(e) => {
                        e.stopPropagation();
                        this.handleRemoveQuestion(qIndex);
                      }}>
                        {RecognitionCloseIcon('#DA6C74')}
                      </div>} */}
                    <div
                      style={{
                        transform:
                          activeQuestion === qIndex ? "rotate(0deg)" : "rotate(180deg)",
                        transition: "0.3s",
                      }}
                    >
                      {WeekDropdownIcon("#DA6C74")}
                    </div>
                  </WeekContainer>

                  {qIndex !== questions.length - 1 ? (
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  ) :
                    (activeQuestion === qIndex && (
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    ))}

                  {/* Body only visible if this question is active */}
                  {activeQuestion === qIndex && (
                    <div className="formBody">
                      {/* Question Input */}
                      <InputContainer>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("What would you like to ask?")}<span>*</span>
                        </StyledLabel>
                        <StyledInputV2
                          placeholder={this.props.t("Enter question")}
                          value={q.text}
                          onChange={(e) => this.handleQuestionChange(qIndex, e)}
                          maxLength="150"
                          style={{ background: "white" }}
                          pColor="#BDBDBD"
                          color="#184A61"
                          border="1px solid #BDBDBD"
                        />
                        <div className="count">{q.text.length}/150 | C</div>
                      </InputContainer>

                      <Border
                        style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }}
                      />

                      {/* Options */}
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <StyledLabel isFont="14px" color="#184A61" margin="0px">
                            {this.props.t("Options")}<span>*</span>
                          </StyledLabel>
                          <ToggleContainer>
                            <ToggleWrapper
                              active={q.allowMultiple}
                              onClick={() => this.toggleSwitch(qIndex)}
                            >
                              <ToggleCircle active={q.allowMultiple} />
                            </ToggleWrapper>
                            <div className="respondsText">
                              Allow respondents to select multiple answers
                            </div>
                          </ToggleContainer>
                        </div>



                        {q.options.map((option, index) => (
                          <OptionsContainer
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "12px",
                            }}
                          >
                            {/* Label A B C */}
                            <div className="questionsText">
                              <div className="questionsNumber">
                                {/* {optionLabels[index]} */}
                                {String.fromCharCode(65 + index)}
                              </div>
                            </div>

                            {/* ✅ Wrapper */}
                            <div style={{ position: "relative", flex: 1 }}>

                              <StyledInputV2
                                placeholder={this.props.t("Add option")}
                                value={option}
                                onChange={(e) => this.handleOptionChange(qIndex, index, e)}
                                maxLength="300"
                                style={{
                                  background: "white",
                                  width: "100%",
                                  paddingRight: q.options.length > 2 && index >= 2 ? "35px" : "12px", // space for icon
                                }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />

                              {/* ✅ Icon INSIDE input */}
                              {q.options.length > 2 && index >= 2 && (
                                <div
                                  onClick={() => this.handleRemoveOption(qIndex, index)}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {RemoveIcon()}
                                </div>
                              )}

                            </div>
                          </OptionsContainer>
                        ))}

                        <MoreOptionText onClick={() => this.handleAddOption(qIndex)}>
                          <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                          <div className="addOptionsText" >
                            Add options
                          </div>
                        </MoreOptionText>

                        {/* {q.options.length < 5 && (
                          <MoreOptionText onClick={() => this.handleAddOption(qIndex)}>
                            <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                            <div className="addOptionsText" >
                              Add options (Max 5)
                            </div>
                          </MoreOptionText>
                        )} */}
                      </div>

                      <Border
                        style={{ background: "#EFEFEF", margin: "8px 0 0 0px" }}
                      />
                    </div>
                  )}
                </div>
              ))}

              <div>
                <MoreOptionText isMargin={"8px 0"} onClick={this.handleAddQuestion}>
                  <div className="icon" style={{background:"#FCF2F3",borderRadius:"4px"}}>{AddIconRecognition("#DA6C74")}</div>
                  <div
                    className="addOptionsText"

                  >
                    Add Question
                  </div>
                </MoreOptionText>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  handleAddFeedBackQuestion = () => {
    this.setState((prevState) => ({
      feedBackQuestions: [
        ...prevState.feedBackQuestions,
        { text: "", options: ["", ""], allowMultiple: false }
      ],
      feedbackActiveQuestion: prevState.feedBackQuestions.length
    }));
  };


  handleRemoveFeedBackOption = (qIndex, optionIndex) => {
    this.setState((prevState) => {
      const newQuestions = [...prevState.feedBackQuestions];

      if (newQuestions[qIndex].options.length <= 2) {
        return prevState;
      }

      newQuestions[qIndex].options.splice(optionIndex, 1);

      return { feedBackQuestions: newQuestions };
    });
  };


  stepFiveForm = () => {
    const {
      step,
      feedBackQuestions,
      feedbackActiveQuestion,
      // levelOpen,
      // challenge_level
    } = this.state;
    // const optionLabels = ["A", "B", "C", "D", "E"];
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isMinHeight={"320px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">
              <StyledLabel isFloat="none" isFontWeight="700" isFont="18px" color="#184A61" margin="0px">
                {this.props.t("Add question you would like to ask the user after challenge ends ")} &nbsp;<div className="optText"> {"(Optional)"}</div> 
              </StyledLabel>

              {/* <WeekContainer
                style={{ cursor: "pointer", marginBottom: "10px" }}
                onClick={() => this.setState({ levelOpen: !levelOpen })}
              >
                <div className="weeekText">Level {challenge_level}</div>
                <div
                  style={{
                    transform: levelOpen ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "0.3s",
                  }}
                >
                  {WeekDropdownIcon("#DA6C74")}
                </div>
              </WeekContainer> */}
              {/* Loop through questions */}
              { (feedBackQuestions.map((q, qIndex) => (
                <div key={qIndex}>
                  {/* Question Header */}
                  <WeekContainer
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        feedbackActiveQuestion: feedbackActiveQuestion === qIndex ? null : qIndex,
                      })
                    }
                  >
                    <div className="weeekText">Question {qIndex + 1}</div>
                    <div
                      style={{
                        transform:
                          feedbackActiveQuestion === qIndex ? "rotate(0deg)" : "rotate(180deg)",
                        transition: "0.3s",
                      }}
                    >
                      {WeekDropdownIcon("#DA6C74")}
                    </div>
                  </WeekContainer>


                  {qIndex !== feedBackQuestions.length - 1 ? (
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  ) :
                    (feedbackActiveQuestion === qIndex && (
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    ))}

                  {/* Body only visible if this question is active */}
                  {feedbackActiveQuestion === qIndex && (
                    <div className="formBody">
                      {/* Question Input */}
                      <InputContainer>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("What would you like to ask?")}
                        </StyledLabel>
                        <StyledInputV2
                          placeholder={this.props.t("Enter question")}
                          value={q.text}
                          onChange={(e) => this.handleFeedBackQuestionChange(qIndex, e)}
                          maxLength="150"
                          style={{ background: "white" }}
                          pColor="#BDBDBD"
                          color="#184A61"
                          border="1px solid #BDBDBD"
                        />
                        <div className="count">{q.text.length}/150 | C</div>
                      </InputContainer>

                      <Border
                        style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }}
                      />

                      {/* Options */}
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <StyledLabel isFont="14px" color="#184A61" margin="0px">
                            {this.props.t("Options")}
                          </StyledLabel>
                          <ToggleContainer>
                            <ToggleWrapper
                              active={q.allowMultiple}
                              onClick={() => this.toggleFeedBackSwitch(qIndex)}
                            >
                              <ToggleCircle active={q.allowMultiple} />
                            </ToggleWrapper>
                            <div className="respondsText">
                              Allow respondents to select multiple answers
                            </div>
                          </ToggleContainer>
                        </div>

                        {q.options.map((option, index) => (
                          <OptionsContainer
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "8px",
                            }}
                          >
                            {/* Label */}
                            <div className="questionsText">
                              <div className="questionsNumber">
                                {/* {optionLabels[index]} */}
                                {String.fromCharCode(65 + index)}
                              </div>
                            </div>

                            {/* ✅ Wrapper (IMPORTANT) */}
                            <div style={{ position: "relative", flex: 1 }}>

                              <StyledInputV2
                                placeholder={this.props.t("Add option")}
                                value={option}
                                onChange={(e) => this.handleFeedBackOptionChange(qIndex, index, e)}
                                maxLength="300"
                                style={{
                                  background: "white",
                                  width: "100%",
                                  paddingRight:
                                    q.options.length > 2 && index >= 2 ? "35px" : "12px",
                                }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />

                              {/* ✅ Icon INSIDE input */}
                              {q.options.length > 2 && index >= 2 && (
                                <div
                                  onClick={() =>
                                    this.handleRemoveFeedBackOption(qIndex, index)
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {RemoveIcon()}
                                </div>
                              )}
                            </div>
                          </OptionsContainer>
                        ))}

                        <MoreOptionText onClick={() => this.handleFeedBackAddOption(qIndex)}>
                          <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                          <div className="addOptionsText" >
                            Add options
                          </div>
                        </MoreOptionText>

                        {/* {q.options.length < 5 && (
                          <MoreOptionText onClick={() => this.handleFeedBackAddOption(qIndex)}>
                            <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                            <div className="addOptionsText" >
                              Add options (Max 5)
                            </div>
                          </MoreOptionText>
                        )} */}
                      </div>
                      {/* Toggle */}
                      <Border
                        style={{ background: "#EFEFEF", margin: "8px 0 0 0px" }}
                      />
                    </div>
                  )}
                </div>
              )))}

              <div>
                <MoreOptionText isMargin={"8px 0px"} onClick={this.handleAddFeedBackQuestion}>
                  <div className="icon" style={{background:"#FCF2F3",borderRadius:"4px"}}>{AddIconRecognition("#DA6C74")}</div>
                  <div
                    className="addOptionsText"
                  >
                    Add Question
                  </div>
                </MoreOptionText>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    )
  }


  // isNextDisabled = () => {
  //   const { weeksData } = this.state;
  //   window.console.log("weeksData", weeksData);
  //   return weeksData.some((week) =>
  //     week.some((day) => day?.task?.trim() === "")
  //   );
  // };


  isNextDisabled = () => {
    const { weeksData } = this.state;
  
    return weeksData.some((week) =>
      week.some((day) => {
        const task = typeof day.task === "string" ? day.task : "";
        return task.trim() === "";
      })
    );
  };

 
  isStepFourNextDisabled = () => {
    const { questions } = this.state;

    return questions.some((q) => {
      const filledOptions = q.options.filter((opt) => opt.trim() !== "");
      return filledOptions.length < 2 || q.text.trim() === "";
    });
  };


  isStepFiveNextDisabled = () => {
    const { feedBackQuestions } = this.state;
  
    return feedBackQuestions.some((q) => {
      const hasQuestion = q.text && q.text.trim() !== "";
  
      const filledOptions = q.options.filter(
        (opt) => opt && opt.trim() !== ""
      );
  
      const hasAnyOption = filledOptions.length > 0;
  
      if (!hasQuestion && !hasAnyOption) {
        return false;
      }
  
      if (hasQuestion && filledOptions.length < 2) {
        return true;
      }
  
      if (!hasQuestion && hasAnyOption) {
        return true;
      }
  
      return false;
    });
  };
  

  render() {
    const {
      description,
      imgSrc,
      charCount,
      step,
      title,
      videoTitle,
      videoUrl,
      challenge_level,
      challengePointValue,
      loading,
      selectedLinkOption,
      audio_link

    } = this.state;

    if (loading) {
      return <Waiting />;
    }


    const isStep2Disabled =
    selectedLinkOption === 0
      ? (!audio_link || !challenge_level || !challengePointValue)
      : (!videoUrl || !videoTitle || !challenge_level || !challengePointValue);

    // const isDisabled = !goldBadgeImgSrc || !silverBadgeImgSrc|| !bronzeBadgeImgSrc;

    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : step === 2 ? this.stepTwoForm() : step === 3 ? this.stepThreeForm() : step === 4 ? this.stepFourForm() : this.stepFiveForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title || !imgSrc ||  !description || (charCount > 3000)} onClick={!title || !imgSrc || !description || (charCount > 3000) ? null : () => this.updateStep(2)}>
                Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"

                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"
                // disabled={isDisabled}
                disabled={isStep2Disabled}
                onClick={isStep2Disabled ? null : () => this.updateStep(3)}
                // disabled={ !videoUrl  || !videoTitle  || !challenge_level || !challengePointValue}
                // onClick={
                //   !videoUrl  || !videoTitle  ||  !challenge_level || !challengePointValue
                //     ? null
                //     : () => this.updateStep(3)
                // }
              // onClick={!buttonstatus ? isEditCategory? () => this.editOndemandEvent() :  () => this.saveOndemandEvent() : null}
              >Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) :
          step === 3 ?
            (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(2)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={this.isNextDisabled()} onClick={this.isNextDisabled() ? null : () => this.updateStep(4)}>
                    Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            ) : step === 4 ? (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(3)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={this.isStepFourNextDisabled()} onClick={this.isStepFourNextDisabled() ? null : () => this.updateStep(5)}>
                    Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            ) : step === 5 && (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(4)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={this.isStepFiveNextDisabled()}  onClick={ this.isStepFiveNextDisabled() ? null : () => this.saveChallengeDetails()}   /*onClick={() => this.saveChallengeDetails()}*/ >
                    Create Challenge
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )
        }
      </React.Fragment>
    );
  }
}

CreateChallengeForm.propTypes = {
  createOndemand: PropTypes.func.isRequired,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  EditOndemandEventVideo: PropTypes.func,
};

export default (withTranslation()(CreateChallengeForm));